import React, { useEffect, useRef, useState } from 'react';
import { useInView, useReducedMotion } from 'framer-motion';
type StatNumberProps = {
  value: number;
  prefix?: string;
  suffix?: string;
  className?: string;
};
const formatter = new Intl.NumberFormat('it-IT');
export function StatNumber({
  value,
  prefix = '',
  suffix = '',
  className = ''
}: StatNumberProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {
    once: true,
    amount: 0.6
  });
  const reduceMotion = useReducedMotion();
  const [current, setCurrent] = useState<number>(0);
  useEffect(() => {
    if (reduceMotion) {
      setCurrent(value);
      return;
    }
    if (!inView) return;
    let frame = 0;
    const start = performance.now();
    const duration = 1000;
    const tick = (now: number) => {
      const progress = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCurrent(Math.round(value * eased));
      if (progress < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [inView, reduceMotion, value]);
  return <span ref={ref} className={`tabular-nums ${className}`} data-id="element-220" data-mp="21566vvkswcwh">
      {prefix}
      {formatter.format(current)}
      {suffix}
    </span>;
}